import { useDeviceControlProps } from "@/hooks/useDeviceControl";
import { Slot } from "@frend-digital/ui";
import { type SbBlokData, storyblokEditable } from "@storyblok/react/rsc";
import type { ComponentProps, PropsWithChildren } from "react";
import type { ISbComponentType } from "storyblok-js-client";

export interface BlokWrapProps extends ComponentProps<"div"> {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	editable: ISbComponentType<any>;
	layout?: "page" | "full" | "section";
	as?: "div" | "section" | "article" | "main";
	asChild?: boolean;
	dataBlok?: boolean;
}

const BlokWrap = ({
	children,
	editable,
	layout,
	as: Component = "section",
	asChild,
	dataBlok = true,
	...rest
}: PropsWithChildren<BlokWrapProps>) => {
	const ComponentToUse = asChild ? Slot : Component;
	const deviceProps = useDeviceControlProps(editable);
	const editableAnchor = (editable as { anchor?: unknown }).anchor;
	const anchor = typeof editableAnchor === "string" && editableAnchor ? editableAnchor : undefined;
	const props = {
		...rest,
		id: rest.id ?? anchor,
		"data-blok": dataBlok ? true : undefined,
		"data-blok-name": process.env.NODE_ENV === "development" ? editable.component : undefined,
	};
	return (
		<ComponentToUse {...deviceProps} {...storyblokEditable(editable as SbBlokData)} {...props}>
			{children}
		</ComponentToUse>
	);
};

export default BlokWrap;
